module.exports = __webpack_public_path__ + "img/experience.6b0e1d1c.svg";